/* Wafmiou — passe mobile (04/11/2026). Chargé en defer. Aucun texte ici : les textes viennent du Liquid (traduits). */
(() => {
  const reduit = matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- « 69 € » : espace insécable entre le montant et l'euro, dans tous les textes (contenus Shopify compris) ---------- */
  const insecable = (racine) => {
    const tw = document.createTreeWalker(racine, NodeFilter.SHOW_TEXT, { acceptNode: (n) => (/\d[ \u202F]€/.test(n.nodeValue) && !n.parentElement.closest('script,style,textarea') ? 1 : 3) });
    const lst = []; for (let n; (n = tw.nextNode());) lst.push(n);
    for (const n of lst) n.nodeValue = n.nodeValue.replace(/(\d)[ \u202F]€/g, '$1\u00A0€');
  };
  insecable(document.body);
  // contenus ajoutés plus tard (panier, filtres, variantes)
  new MutationObserver((ms) => { for (const m of ms) for (const n of m.addedNodes) if (n.nodeType === 1) insecable(n); })
    .observe(document.body, { childList: true, subtree: true });

  /* ---------- Menu : sous-niveaux qui glissent ---------- */
  const menu = () => document.querySelector('[data-wmm]');
  const fermeSous = (m, rendFocus = true) => {
    const ouvert = m.querySelector('.wmm__panneau--sous.est-ouvert');
    if (!ouvert) return;
    const opener = m.querySelector(`[data-wmm-ouvre="${ouvert.id}"]`);
    ouvert.classList.remove('est-ouvert');
    m.classList.remove('a-un-sous');
    opener?.setAttribute('aria-expanded', 'false');
    const fin = () => { ouvert.hidden = true; };
    reduit ? fin() : setTimeout(fin, 420);
    if (rendFocus) opener?.focus({ preventScroll: true });
  };
  const ouvreSous = (m, id) => {
    const p = m.querySelector('#' + CSS.escape(id));
    if (!p) return;
    p.hidden = false;
    p.scrollTop = 0;
    requestAnimationFrame(() => requestAnimationFrame(() => {
      p.classList.add('est-ouvert');
      m.classList.add('a-un-sous');
      m.querySelector(`[data-wmm-ouvre="${id}"]`)?.setAttribute('aria-expanded', 'true');
      p.querySelector('[data-wmm-retour]')?.focus({ preventScroll: true });
    }));
  };
  document.addEventListener('click', (e) => {
    const m = menu(); if (!m) return;
    const o = e.target.closest('[data-wmm-ouvre]');
    if (o && m.contains(o)) { e.preventDefault(); ouvreSous(m, o.dataset.wmmOuvre); return; }
    const r = e.target.closest('[data-wmm-retour]');
    if (r && m.contains(r)) { e.preventDefault(); fermeSous(m); }
  });
  // Échap : d'abord revenir au 1er niveau, puis (2e appui) Horizon ferme le tiroir
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    const m = menu();
    if (m && m.classList.contains('a-un-sous')) { e.stopPropagation(); e.preventDefault(); fermeSous(m); }
  }, true);
  // Tiroir refermé → on remet le 1er niveau
  const details = document.getElementById('Details-menu-drawer-container');
  if (details) {
    new MutationObserver(() => {
      const m = menu();
      if (m && !details.classList.contains('menu-open')) fermeSous(m, false);
    }).observe(details, { attributes: true, attributeFilter: ['class'] });
  }
  // Photos du tiroir : chargées dès qu'on touche le bouton menu (pas sur chaque page)
  document.addEventListener('pointerdown', (e) => {
    if (!e.target.closest('.header__icon--menu')) return;
    for (const im of document.querySelectorAll('.wmm img[loading="lazy"]')) im.loading = 'eager';
  }, { passive: true });
  // Sélecteur de langue / pays : envoi au changement
  document.addEventListener('change', (e) => {
    const s = e.target.closest('[data-wmm-langue]');
    if (s) s.form.submit();
  });

  /* ---------- Apparition douce au défilement (jamais sur le 1er écran : pas d'effet sur le LCP) ---------- */
  if (!reduit && 'IntersectionObserver' in window) {
    const cibles = [...document.querySelectorAll('main .shopify-section')].slice(1)
      .filter((s) => s.getBoundingClientRect().top > innerHeight * 0.9);
    const io = new IntersectionObserver((entrees) => {
      for (const en of entrees) {
        if (!en.isIntersecting) continue;
        en.target.classList.add('wmx-vu');
        en.target.classList.remove('wmx-cache');
        io.unobserve(en.target);
      }
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
    for (const s of cibles) { s.classList.add('wmx-cache'); io.observe(s); }
    // impression : tout visible
    addEventListener('beforeprint', () => cibles.forEach((s) => s.classList.remove('wmx-cache')));
  }

  /* ---------- Points sous les carrousels ---------- */
  for (const c of document.querySelectorAll('[data-wmx-points]')) {
    const items = [...c.children];
    if (items.length < 3) continue;
    const pts = document.createElement('div');
    pts.className = 'wmx-glisse'; pts.setAttribute('aria-hidden', 'true');
    items.forEach(() => pts.appendChild(document.createElement('i')));
    c.after(pts);
    const maj = () => {
      const max = c.scrollWidth - c.clientWidth;
      const k = max <= 0 ? 0 : Math.round((c.scrollLeft / max) * (items.length - 1));
      [...pts.children].forEach((p, i) => p.classList.toggle('est-actif', i === k));
    };
    c.addEventListener('scroll', maj, { passive: true }); maj();
  }

  /* ---------- Pastilles couleur sur les cartes : changent la photo et le lien, sans recharger ---------- */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('.wmx-pastille');
    if (!b) return;
    e.preventDefault(); e.stopPropagation();
    // la carte = l'élément de grille autour de la liste de pastilles (pas le <li> de la pastille)
    const liste = b.closest('.wmx-pastilles');
    const carte = liste?.parentElement?.closest('[data-wmx-carte], .product-grid__item, .wm-model, li');
    if (!carte) return;
    const href = b.dataset.href;
    for (const a of carte.querySelectorAll('a[href*="/products/"]')) a.href = href;
    const img = carte.querySelector('img:not(.wmx-pastille img)');
    if (img && b.dataset.img) {
      img.removeAttribute('srcset'); img.removeAttribute('sizes');
      img.src = b.dataset.img; img.alt = b.dataset.nom || img.alt;
      const src = img.closest('picture')?.querySelectorAll('source'); src?.forEach((s) => s.remove());
    }
    for (const x of carte.querySelectorAll('.wmx-pastille')) x.setAttribute('aria-current', x === b ? 'true' : 'false');
    const nom = carte.querySelector('[data-wmx-coloris]'); if (nom) nom.textContent = b.dataset.nom || '';
  }, true);

  /* ---------- Textes repliés à 3 lignes (le texte complet reste dans la page) ---------- */
  for (const r of document.querySelectorAll('.wmx-repli')) {
    if (r.scrollHeight <= r.clientHeight + 4) { r.classList.add('wmx-repli--court'); continue; }
    const b = document.createElement('button');
    b.type = 'button'; b.className = 'wmx-repli__btn'; b.textContent = r.dataset.wmxPlus || '+';
    b.setAttribute('aria-expanded', 'false');
    b.addEventListener('click', () => { r.classList.add('est-deplie'); b.remove(); });
    r.after(b);
  }
})();
